<template>
  <section
    id="chat"
    :class="{'announcement-space': showAnnouncement }">
    <Conversations
      ref="Conversations"
      :conversation-id="conversationId"/>
    <Messages/>
    <transition
      v-if="!firstConversationsPageLoading && !hideDetails && activeConversation && activeConversation.id && !activeConversation.id.startsWith('TEMP-conversation')"
      name="user-details">
      <!-- <keep-alive> -->
      <UserDetails
        v-if="!firstConversationsPageLoading && userDetailsSectionShown && !hideDetails"
        :section="userDetailsSectionShown"
        :conversation="currentConversation"/>
      <!-- </keep-alive> -->
    </transition>
    <UserActions v-if="!firstConversationsPageLoading && !hideDetails && activeConversation && activeConversation.id && !activeConversation.id.startsWith('TEMP-conversation')"/>
  </section>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import '@/assets/css/modules/_chat.scss';
import ChatEventBus from '../business/chat/ChatEventBus';
import UserDetails from '../business/chat/partials/UserDetails';
import UserActions from '../business/chat/partials/UserActions';
import Conversations from '../business/chat/Conversations';
import Messages from '../business/chat/Messages';

export default {
  name: 'OrgChat',
  components: {
    Conversations,
    Messages,
    UserDetails,
    UserActions,
  },
  props: {
    // organisationId: {
    //   type: String,
    //   required: true,
    // },
    businessId: {
      type: String,
      required: false,
      default: '',
    },
    conversationId: {
      type: String,
      required: false,
      default: '',
    },
  },
  data() {
    return {
      currentConversation: {},
      folder: 'open',
      assignment: 'all',
      userDetailsSectionShown: null,
      hideDetails: false,
    };
  },
  computed: {
    // mix the getters into computed with object spread operator
    ...mapGetters({
      currentOrganisationBusinessIds: 'organisation/currentOrganisationBusinessIds',
      activeConversation: 'chat/activeConversation',
      currentOrganisation: 'organisation/currentOrganisation',
      conversationsLoad: 'chat/conversationsLoad',
      showAnnouncement: 'system/showAnnouncement',
    }),
    firstConversationsPageLoading() {
      return !this.conversationsLoad.loaded && this.conversationsLoad.page === 1;
    },
  },
  watch: {
    conversationId() {
      // TODO changing the conversation should update the route
    },
  },
  created() {
    // console.log('created OrganisationChat.vue');
    this.clearChatData();
  },
  beforeMount() {
    if (this.businessId && !this.currentOrganisationBusinessIds.includes(this.businessId)) {
      this.$router.replace({ name: 'OrganisationWithId', params: { businessId: '' } });
    }
  },
  mounted() {
    // console.log('mounted OrganisationChat.vue');

    window.addEventListener('blur', this.onBlur);
    window.addEventListener('focus', this.onFocus);

    // this.joinFocusChannel(this.currentOrganisation.id);

    ChatEventBus.$on('showUserDetails', (section) => {
      if (section === 'null') {
        section = null;
      }
      this.userDetailsSectionShown = section;
    });

    this.$eventBus.$on('show-contact-search-view', () => { this.hideDetails = true; });
    this.$eventBus.$on('close-new-conversation-bar', () => { this.hideDetails = false; });
    this.$eventBus.$on('enable-new-message', () => { this.hideDetails = false; });
  },
  beforeDestroy() {
    this.clearChatData();
    this.$eventBus.$off('contactDataChanged');

    window.removeEventListener('blur', this.onBlur);
    window.removeEventListener('focus', this.onFocus);

    // this.leaveFocusChannel(this.currentOrganisation.id);
    this.setActiveConversation({});
  },
  methods: {
    ...mapActions({
      clearChatData: 'chat/clearChatData',
      // joinFocusChannel: 'pusher/joinFocusChannel',
      // leaveFocusChannel: 'pusher/leaveFocusChannel',
      setActiveConversation: 'chat/setActiveConversation',
    }),
    onBlur() {
      // this.leaveFocusChannel(this.currentOrganisation.id);
    },
    onFocus() {
      // this.joinFocusChannel(this.currentOrganisation.id);
    },
    checkFolderChangingAbility() {
      this.$refs.Messages.detectFolderChangingAbility();
    },
    changeConversation(conversation) {
      if (conversation) {
        this.currentConversation = conversation;
        this.$nextTick(() => {
          this.$refs.Messages.detectFolderChangingAbility();
        });
      } else {
        this.currentConversation = {};
      }
    },
    changeActiveFolder(folder) {
      this.folder = folder;
    },
    changeAssignmentFolder(assignment) {
      this.assignment = assignment;
    },
  },
};
</script>

<style lang="scss" scoped>
#chat {
  display: flex;
  width: calc(100% - 258px);
}

.user-details-enter {
  width: 0px!important
}

.user-details-leave-to {
  width: 0px!important;
}
</style>
